import Input from "../../core/Input";
import React from "react";
import {useIntl, FormattedMessage} from 'react-intl';

function AgeThresholdQuestions({register, errors, type}) {
  const intl = useIntl();
  const form = {
    annualPensionIncome: {
      formName: (type === "applicant") ? "ApplicantAnnualPensionIncome" : "PartnerAnnualPensionIncome",
      error: (type === "applicant") ? errors.ApplicantAnnualPensionIncome : errors.PartnerAnnualPensionIncome
    },
    aow: {
      formName: (type === "applicant") ? "ApplicantAOW" : "PartnerAOW",
      error: (type === "applicant") ? errors.ApplicantAOW : errors.PartnerAOW
    }
  }
  return (
  <div className="ct-step__body-secondary-subquestions">
    <div>
      <div className="ct-step__body-subquestion">
        <FormattedMessage
        id="step1.ageThreshold.pensionIncomeQuestion"
        defaultMessage="Wat is de hoogte van {type} pensioeninkomen per jaar?"
        values={{
          type: type === "applicant" ? intl.formatMessage({
            id: "step1.ageThreshold.pensionIncomeQuestion.applicantType",
            defaultMessage: "je"
          }) : intl.formatMessage({id: "step1.ageThreshold.pensionIncomeQuestion.partnerType", defaultMessage: "je partner"})
        }}
        />
      </div>

      <div className="ct-step__body-tip">
        <FormattedMessage
        id="step1.ageThreshold.pensionIncomeTip"
        defaultMessage="Dit kun je vinden in {pensionLink}."
        values={{
          pensionLink: (
          <a href="https://www.mijnpensioenoverzicht.nl"
             target="_blank"
             rel="noopener noreferrer">
            {intl.formatMessage({
              id: "step1.ageThreshold.pensionIncomeTip.pensionLink",
              defaultMessage: "Mijn Pensioenoverzicht"
            })}
          </a>
          )
        }}
        />
      </div>

      <Input
      placeholder="€"
      type="currency"
      register={register}
      validationRules={{required: false}}
      name={form.annualPensionIncome.formName}
      error={form.annualPensionIncome.error}
      errorTitle="pensioeninkomen"
      />
    </div>

    <div>
      <div className="ct-step__body-subquestion">
        <FormattedMessage
        id="step1.ageThreshold.aowQuestion"
        defaultMessage="Wat is de hoogte van de AOW?"
        />
      </div>

      <div className="ct-step__body-tip">
        <FormattedMessage
        id="step1.ageThreshold.pensionIncomeTip"
        defaultMessage="Dit kun je vinden in {pensionLink}."
        values={{
          pensionLink: (
          <a href="https://www.mijnpensioenoverzicht.nl"
             target="_blank"
             rel="noopener noreferrer">
            {intl.formatMessage({
              id: "step1.ageThreshold.pensionIncomeTip.pensionLink",
              defaultMessage: "Mijn Pensioenoverzicht"
            })}
          </a>
          )
        }}
        />
      </div>

      <Input
      placeholder="€"
      type="currency"
      register={register}
      validationRules={{required: false}}
      name={form.aow.formName}
      error={form.aow.error}
      errorTitle="AOW"
      />
    </div>
  </div>
  );
};

export default AgeThresholdQuestions;
